import { type ChangeEvent, type ReactNode, useEffect, useRef, useState } from 'react';
import { Icon } from './Icon.tsx';

interface TopbarProps {
  title: string;
  sub?: string;
  actions?: ReactNode;
  notifyCount: number;
  onBell: () => void;
  onSearch?: (q: string) => void;
}

export function Topbar({ title, sub, actions, notifyCount, onBell, onSearch }: TopbarProps) {
  const [query, setQuery] = useState('');
  const searchTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (searchTimer.current) {
        clearTimeout(searchTimer.current);
      }
    };
  }, []);

  function handleSearchChange(event: ChangeEvent<HTMLInputElement>) {
    const nextQuery = event.target.value;
    setQuery(nextQuery);

    if (!onSearch) return;
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }
    searchTimer.current = setTimeout(() => {
      onSearch(nextQuery);
    }, 300);
  }

  return (
    <header className="topbar">
      <div className="topbar-title">
        <h1>{title}</h1>
        {sub && <div className="sub">{sub}</div>}
      </div>

      {onSearch && (
        <label className="search" aria-label="Поиск">
          <Icon name="search" size={14} aria-hidden="true" />
          <input type="search" placeholder="Поиск" value={query} onChange={handleSearchChange} />
        </label>
      )}

      {actions && <div className="topbar-actions">{actions}</div>}

      <button className="topbar-bell" type="button" onClick={onBell} aria-label="Уведомления">
        <Icon name="bell" size={18} aria-hidden="true" />
        {notifyCount > 0 && <span className="badge-new">{notifyCount}</span>}
      </button>
    </header>
  );
}
